const redeemPageFields = `
  couponCode
  heading
  backgroundImage {
    url
  },
  badgeText
  intro
  goalText {
    heading
    text
  }
  showAppButtons
  customAppStoreUrl
  customGooglePlayUrl
  legacyDontUseMainImage
`

module.exports = {
  query: (slug, locale) => `
    {
      redeemPage(filter: {couponCode: {matches: {pattern: "${slug}", caseSensitive: false }}}, locale: ${locale}) {
        ${redeemPageFields}
      }
    }
  `,
  queryAll: locale => `
  {
    allRedeemPages(locale: ${locale}) {
      ${redeemPageFields}
    }
  }
  `,
}
